module.exports = __webpack_public_path__ + "img/cat-infantil.f6732d0a.jpg";